import { render, staticRenderFns } from "./AuditRefuseDialog.vue?vue&type=template&id=879a1672&scoped=true&"
import script from "./AuditRefuseDialog.vue?vue&type=script&lang=js&"
export * from "./AuditRefuseDialog.vue?vue&type=script&lang=js&"
import style0 from "./AuditRefuseDialog.vue?vue&type=style&index=0&id=879a1672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879a1672",
  null
  
)

export default component.exports